(function ($) {
    'use strict';
    $(document).ready(function () {
        var codes = [
            {
                selector: "#sylius_taxon_code",
                prefix: "category_"
            },
            {
                selector: "#sylius_product_code",
                prefix: "item_"
            },
            {
                selector: "#sylius_product_attribute_code",
                prefix: "attribute_"
            },
            {
                selector: "#sylius_product_option_code",
                prefix: "option_"
            },
            {
                selector: "#sylius_product_option_values input[id$='_code']",
                prefix: "value_"
            },
            {
                selector: "#sylius_customer_group_code",
                prefix: "group_"
            },
            {
                selector: "#sylius_channel_code",
                prefix: "company_"
            },
            {
                selector: "#sylius_zone_code",
                prefix: "zone_"
            },
            {
                selector: "#sylius_payment_method_code",
                prefix: "payment_method_"
            },
            {
                selector: "#sylius_shipping_method_code",
                prefix: "shipping_method_"
            },
            {
                selector: "#sylius_tax_rate_code",
                prefix: "tax_rate_"
            },
            {
                selector: "#csl_stock_order_code",
                prefix: "stock_order_"
            },
            {
                selector: "#csl_gift_cart_code",
                prefix: "gift_cart_"
            },
            {
                selector: "#csl_points_code",
                prefix: "points_"
            }
        ];

        var init = function () {
            for (var i in codes) {
                var code = codes[i];
                var elements = $(code.selector);
                elements.each(function () {
                    if (!$(this).val()) {
                        $(this).val(code.prefix + Math.random().toString(36).substring(7));
                    }
                });
            }
        };

        init();

        $("#sylius_product_option_values").on("click", 'a[data-form-collection="add"]', function () {
            init();
        });
    });
})(jQuery);